// extracted by mini-css-extract-plugin
export default {"offers":"_1ExSaL7YG6F114FLTwvWZO","offer":"_3mnKLm2MHAz6fbTHpMcqT3","top":"_2ZWemOQg5P20ajNBWi6Dcq","title":"_1_pNXBjqXVmrXB2DtC5iY9","desc":"_3hfcrDcMa4LIonhFd0oxZy"};